import React, { useState } from 'react';
import Modal from '../../utils/modalUtils';
import authApiService from '../../services/authServices';
import './resetpassword.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    // const email = location.state?.email || '';
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email') || '';
    const token = queryParams.get('token') || '';
    console.log("first", token)

    const validate = () => {
        const newErrors = {};

        if (!newPassword) {
            newErrors.newPassword = 'New password is required.';
        } else if (newPassword.length < 6) {
            newErrors.newPassword = 'Password must be at least 6 characters.';
        }

        if (!confirmPassword) {
            newErrors.confirmPassword = 'Please confirm your password.';
        } else if (newPassword !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setIsLoading(true);

        try {
            const response = await authApiService.post(`reset-password?token=${token}`, {
                password: newPassword,
                confirmPassword: confirmPassword,
            });

            if (response.code === 200) {
                Modal.fire({
                    icon: 'success',
                    title: 'Password Updated',
                    text: 'Your password has been successfully reset.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#addd1e'
                }).then(() => {
                    window.location.href = '/';
                });
                setNewPassword('');
                setConfirmPassword('');
            } else {
                Modal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data?.message || 'Unable to reset password.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#addd1e'
                });
            }
        } catch (error) {
            console.error('Error resetting password:', error);
            Modal.fire({
                icon: 'error',
                title: 'Server Error',
                text: error.response?.data?.message || 'Something went wrong. Please try again.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#addd1e'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    return (
        <div className="reset-password-page">
            <div className="reset-password-container">
                <h2 style={{ color: 'white' }}>Reset Your Password</h2>
                <form onSubmit={handleSubmit} className="reset-password-form">
                    {/* <div className="input-group">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Enter New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="login-input"
                        />
                        <button
                            className="btn btn-light"
                            type="button"
                            onClick={togglePasswordVisibility}
                        >
                            <Icon
                                path={showPassword ? mdiEyeOutline : mdiEyeOffOutline}
                                size={1}
                                color="currentColor"
                            />
                        </button>
                        {errors.newPassword && <p className="error-message">{errors.newPassword}</p>}
                    </div> */}


                    <div className="input-wrapper">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            placeholder="Enter New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="login-input with-icon"
                        />
                        <span
                            className="password-toggle-icon"
                            onClick={togglePasswordVisibility}
                        >
                            <Icon
                                path={showPassword ? mdiEyeOutline : mdiEyeOffOutline}
                                size={1}
                                color="#9cb23b"
                            />
                        </span>
                        {errors.newPassword && <p className="error-message">{errors.newPassword}</p>}
                    </div>


                    <div className="input-group">
                        <input
                            type={showConfirmPassword ? 'text' : 'password'}
                            placeholder="Re-enter New Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className="login-input"
                        />
                        <span
                            className="password-toggle-icon"
                            onClick={toggleConfirmPasswordVisibility}
                        >
                            <Icon
                                path={showConfirmPassword ? mdiEyeOutline : mdiEyeOffOutline}
                                size={1}
                                color="#9cb23b"
                            />
                        </span>
                        {errors.confirmPassword && (
                            <p className="error-message">{errors.confirmPassword}</p>
                        )}
                    </div>

                    <button type="submit" className="reset submit button" disabled={isLoading}>
                        {isLoading ? 'Submitting...' : 'Set New Password'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;
